import { Box, HStack, Text, type StackProps } from "@chakra-ui/react";
import { LuAlertCircle } from "react-icons/lu";

interface HintProps extends Omit<StackProps, "children"> {
  tone?: "info" | "warning";
  children: React.ReactNode;
}

const TONES = {
  info: { bg: "brand.subtle", icon: "brand.fg" },
  warning: { bg: "yellow.subtle", icon: "yellow.fg" },
} as const;

export const Hint = ({ tone = "info", children, ...rest }: HintProps) => {
  const colors = TONES[tone];
  return (
    <HStack
      role="note"
      align="flex-start"
      gap={2.5}
      px={3}
      py={2.5}
      rounded="md"
      bg={colors.bg}
      fontSize="sm"
      {...rest}
    >
      <Box color={colors.icon} flexShrink={0} mt="1px" display="inline-flex">
        <LuAlertCircle size={16} />
      </Box>
      <Text color="fg" lineHeight="1.45">
        {children}
      </Text>
    </HStack>
  );
};
